import script from "./ProjectManagerForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectManagerForm.vue?vue&type=script&setup=true&lang=js"

import "./ProjectManagerForm.vue?vue&type=style&index=0&id=631e040f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-631e040f"]])

export default __exports__